// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__337CI","colBig":"styles_colBig__1SERK","colSmall":"styles_colSmall__OJ8mw","shopifyNameWrapper":"styles_shopifyNameWrapper__222dm"};